import "./Stats.scss";
import React, { useEffect } from "react";

// Slide
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Stats = ({ dashboardData }) => {
  const totalRuns = dashboardData?.user?.reports_generated + "/" + dashboardData?.max_reports;
  const totalSessions = dashboardData?.total_sessions || 0;

  useEffect(() => {
    adjustFontSize(".num-totalruns");
  }, [totalRuns, totalSessions]);
    
  const adjustFontSize = (selector) => {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
      const textLength = element.textContent.length;
      const rawFontSize = 80 - textLength * 6;
      const fontSize = Math.max(12, Math.min(rawFontSize, 40));
      element.style.fontSize = `${fontSize}px`;
    });
  };
  
  if (!dashboardData) {
    return <div>Loading stats...</div>; // O muestra algún otro mensaje
  }

  // Populate the annually and monthly arrays
  const dataSources = dashboardData.user.data_sources;

  const seen = new Set();
  const uniqueDataSources = dataSources.filter((item) => {
    if (seen.has(item.source_type)) {
      return false; // Ya existe, lo excluye
    }
    seen.add(item.source_type); // No existe, lo agrega al Set
    return true; // Lo incluye en el resultado
  });

  const imagenesmarcas = Object.keys(dashboardData.parsers).map((key) => {
    return dashboardData.parsers[key].logo;
  });

  const settings = {
    dots: false,
    arrows: imagenesmarcas.length > 3,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
  };

  return (
    <div className="stats">
      <div className="totalruns">
        <div className="contenedor-totalruns">
          <div className="cont-totalruns azul">
            <div className="tit">
              <p>Total sessions</p>
            </div>
            <div className="contenedor-num">
              <p className="num-totalruns">
                {totalSessions}
              </p>
              {/* <p className='important-totalruns' >+10% more than previous</p> */}
            </div>
          </div>
          <div className="cont-totalruns rosa">
            <div className="tit">
              <p>Total reports</p>
            </div>
            <div className="contenedor-num">
              <p className="num-totalruns">
                {totalRuns}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="trackers">
        <span className="txt-trackers">
          <p>Data sources</p>
          <p>{dataSources.length} available</p>
        </span>
        <span className="marcas">
          {dataSources.length > 0 ? (
            <Slider {...settings}>
              {uniqueDataSources.map((circuito, index) => (
                <div className="marcas-slide" key={index}>
                  <img
                    className="imgMarcas"
                    src={
                      dashboardData.parsers[circuito.source_type]?.logo ||
                      "default_logo.jpg"
                    }
                    alt={`Circuito ${index + 1}`}
                  />
                </div>
              ))}
            </Slider>
          ) : (
            <p className="noData">No data sources created</p>
          )}
        </span>
      </div>
    </div>
  );
};

export default Stats;
